module.exports = __webpack_public_path__ + "static/img/game-series-168.178ba66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-series-168.png
// module id = 8ArK
// module chunks = 1